import React from 'react';
import { render } from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import debugFactory from 'debug';
import 'focus-visible';
import 'intl-pluralrules'; // polyfill for safari <13

import 'tippy.js/dist/tippy.css';

import { bootstrapConfig } from '~src/config/bootstrap-config';
import { createIpc } from '~src/bootstrap/ipc';
import { ResizeSender } from '~src/bootstrap/resize';

import { GlobalStyles } from '~src/main/theme/global-styles';
import { IpcContext } from '~src/main/utils/ipc-utils';
import { WidgetInit } from '~src/main/widget/widget-init';

const debug = debugFactory('ingrid:bootstrap');

debug('Started faq embed');

document.body.style.margin = '0';
document.body.style.overflow = 'hidden';

export const ipc = createIpc<any>({
  window: window.parent,
  origin: bootstrapConfig.creator,
});

new ResizeSender(document.body, ipc);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      keepPreviousData: true,
      retry: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  },
});

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <IpcContext.Provider value={ipc}>
        <GlobalStyles />
        <WidgetInit />
      </IpcContext.Provider>
    </QueryClientProvider>
  );
};

const container = document.getElementById('root');
render(<App />, container);
